<div class="dialog-container addmasterproduct">
    <div class="dialog-title-block">
      <h2>Add Implant</h2>
      <div class="flex-container gap-2">
        <div class="dialog-btn" (click)="onClose()">
          <img class="dialog-colse-btn" src="../../../assets/images/close.png" alt="close">
        </div>
      </div>
    </div>
    <form #f="ngForm" name="form" novalidate>
      <div class="dialog-content-block p-3">
        <div class="gap-5 w-100 mt-4">
          <div class="flex-column">
            <div class="form-group">
              <h6 class="text-start text-dark">Name</h6>
              <input type="text" name="product_code" [(ngModel)]="nameTxt" value="">
              <div class="form-error-msg"></div>
            </div> 
          </div>
          <div class="flex-column">
            <div class="form-group">
              <div class="cabinet-dropdown stores">
                <h6 class="text-start text-dark">Body part</h6>
                <div class="w-100">
                  <span class="drop-down-btn header d-flex align-items-center justify-content-between" (click)="isBodyPartDropDown.set(!isBodyPartDropDown())">
                    <span>{{ selectedBodyPart.value }}</span>
                    <img src="../../../assets/images/dropdown.png" [class]="isBodyPartDropDown() ? 'drop-down-btn-icon--rotate' : ''" alt="arrow">
                  </span>
                  <ul #dropdownMenu class="dropdown-menu dropdown-content" [class]="isBodyPartDropDown() ? 'd-block' : ''">
                    <li *ngFor="let bodyPart of bodyParts" class="dropdown-item" (click)="onBodyTypeChange(bodyPart)">{{ bodyPart.value }}</li>
                  </ul>
                </div>               
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="dialog-footer">
        <button type="button" (click)="onClose()">Cancel</button>
        <button class="primary-btn addproduct" type="submit" (click)="onAdd()">Add</button>
      </div>
    </form>
  </div>
  